import {Component, Input, OnChanges, SimpleChanges, inject, AfterViewInit, SimpleChange} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/components';
import { MarkupManagerService } from '@wms/core';
import { AppManagerService } from "@wms/design-container";
import { runtimeEventManager } from "@wm/core";
import {ZoomService} from "@wms/page-workspace";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {PageWsService} from "@wms/workspace";

@Component({
  standalone: true,
  selector: 'wms-widget-x-path',
  templateUrl: './wms-widget-x-path.component.html',
  styleUrls: ['./wms-widget-x-path.component.less'],
  imports: [CommonModule, BsDropdownModule],
})
export class WmsWidgetXPathComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Input() activeWidget: any;
  activeElMarkup: any;
  parents: any = [];
  selectedWidgetName: any;
  update: boolean = true;
  hideLeftBtn: boolean;
  hideRightBtn: boolean;
  liWidth: any;
  $pathContainer: any;
  $xPath: any;
  pathWidth: any;
  maxMarginLeft: any;
  zoomService:ZoomService;
  pageWsService:PageWsService

  constructor(private markupManager: MarkupManagerService) {
    super();
    const appManager = inject(AppManagerService);
    this.zoomService = inject(ZoomService);
    this.pageWsService = inject(PageWsService);
    this.registerDestroyListener.add(appManager.subscribe('pageReady', () => {
      this.renderWidgetHierarchy();
    }));
  }

  ngAfterViewInit() {
    this.registerDestroyListener.add(runtimeEventManager.on('widget-name').subscribe((data: any) => {
      if (this.activeElMarkup) {
        let wid = this.activeElMarkup.attr('widgetid');
        let xPathObj = this.parents.find((obj: any) => obj.widgetId === wid);
        xPathObj.name = data.name;
        this.selectedWidgetName = data.name;
      }
    }));

    this.registerDestroyListener.add(this.eventManager.canvasUpdateObservable().subscribe((data: any)=>{
      this.renderWidgetHierarchy();
    }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    const change: SimpleChange = changes['activeWidget'];
    // not triggering it for the first time (as it is handled in page ready subscription
    // not triggering if activeWidget is null (e.g. when moved to script tab)
    if (change && !change.firstChange && change.currentValue) {
      this.renderWidgetHierarchy();
    }
  }


  renderWidgetHierarchy() {
    this.activeElMarkup = this.markupManager.getActiveMarkupEl();
    let parentElMarkup = this.activeElMarkup.parents('[widgetid]');

    this.selectedWidgetName = this.activeElMarkup.attr('name');
    if (!this.update) {
      this.update = true;
      return;
    }

    this.parents = [];

    this.parents.push({
      'widgetId': this.activeElMarkup.attr('widgetid'),
      'name': this.selectedWidgetName
    });

    parentElMarkup.each((el: any) => {
      let name = parentElMarkup[el].getAttribute('name');
      if (name) {
        this.parents.unshift({
          'widgetId': parentElMarkup[el].getAttribute('widgetid'),
          'name': name
        });
      }
    });

    this.$pathContainer = $('.page-widget-x-path');
    this.$xPath = $('ol.breadcrumb');

    setTimeout(() => {
      this.liWidth = 0;
      this.$xPath.children('li').each((el: any) => {
        this.liWidth += $(this.$xPath.children('li')[el]).width();
      });

      this.pathWidth = this.$pathContainer.width();

      if (this.liWidth > this.pathWidth) {
        this.maxMarginLeft = -(this.liWidth - this.pathWidth);
        this.setMarginLeft(this.maxMarginLeft);
        this.hideLeftBtn = false;
        this.hideRightBtn = true;
      } else {
        this.setMarginLeft(0);
        this.hideLeftBtn = true;
        this.hideRightBtn = true;
      }
    }, 0);
  }

  setMarginLeft(marginLeft: any) {
    this.$xPath.animate({
      marginLeft: marginLeft
    }, 250);
  }

  selectWidget(widgetInfo: any) {
    this.update = false;
    this.eventManager.emitOnWidgetSelection(widgetInfo);
  }

  moveRight() {
    let margin = this.$xPath.css('margin-left').replace('px', '');
    let marginLeft: any = parseInt(Math.abs(margin) as any, 0);

    if ((this.liWidth - this.pathWidth) > Math.abs(marginLeft)) {
      marginLeft = -marginLeft - 60;
      this.setMarginLeft(marginLeft);
      this.hideRightBtn = (this.liWidth - this.pathWidth) <= Math.abs(marginLeft);
    } else {
      this.hideRightBtn = false;
    }

    this.hideLeftBtn = marginLeft === 0;
  }

  moveLeft() {
    let marginLeft = parseInt(Math.abs(this.$xPath.css('margin-left').replace('px', '')) as any, 0);
    if (marginLeft <= 60) {
      marginLeft = 0;
      this.hideLeftBtn = true;
    } else {
      marginLeft = -marginLeft + 60;
      this.hideLeftBtn = false;
    }
    this.hideRightBtn = (marginLeft + 60) < this.maxMarginLeft;
    this.setMarginLeft(marginLeft);
  }

}
